import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 28 29"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M25.666 14.405c0 6.44-5.226 11.667-11.666 11.667S2.333 20.845 2.333 14.405 7.56 2.738 14 2.738s11.666 5.227 11.666 11.667"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "m18.328 18.114-3.616-2.158c-.63-.373-1.144-1.272-1.144-2.007V9.166"
    }, null, -1)
  ]))]))
}
export default { render: render }